const ERROR_MESSAGE_TITLE = 'authentication.message.error';
const COULD_NOT_SEND_VERIFICATION_CODE = 'authentication.activation.error.verification-code.not-send';

export class SetEmailController {
    /* @ngInject */
    constructor(passwordCredentialsService, contactPointService, toastr, $log, $translate) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.contactPointService = contactPointService;
        this.toastr = toastr;
        this.$log = $log;
        this.$translate = $translate;

        this.$translate(
            ERROR_MESSAGE_TITLE,
            COULD_NOT_SEND_VERIFICATION_CODE
        ).then((translations) => this.translations = translations);
    }

    $onInit() {
        this.emailVerificationAction = 'VERIFY_EMAIL';
        this.emailTaken = false;

        this.passwordCredentialsService.getUserSecurityContext()
            .then(securityContext => this.userSecurityContext = securityContext)
            .catch(error => this.$log.error(error));

        this.toastr.options = {
            "showDuration": "6000"
        };
    }

    confirmChoice() {
        if (this.email) {
            this.requestVerificationForEmail();
        } else {
            this.noEmail();
        }
    }

    requestVerificationForEmail() {
        this.contactPointService.requestVerificationCodeForContactPoint('VERIFY_EMAIL', this.email)
            .then(() => this.verificationCodeSent())
            .catch(() => this.toastr.error(this.translations[COULD_NOT_SEND_VERIFICATION_CODE], this.translations[ERROR_MESSAGE_TITLE]));
    }
}

export let SetEmailComponent = {
  controller: SetEmailController,
  controllerAs: 'vm',
  templateUrl: 'app/login/email/SetEmailComponent.html',
  bindings: {
      verificationCodeSent: '&',
      noEmail: '&',
      email: '=',
      emailTaken: '='
  }
};
